module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.bf2c26d2.ttf";